import { toSafeObject, toSafeString } from '@shared/utils';
import resolvePieveWorkflowStepIdsInText from '@shared/pieve/resolveWorkflowStepIdsInText.js';
import resolvePieveWorkflowRunFailureDisplay from '@shared/pieve/workflowRunFailureDisplay.js';
import { getFlowActionLabel } from '@/lib/workflowFlowControlMeta.js';

// Shapes workflow_run.meta flow-control records for the run-detail section: tolerated step failures and the notifications
// they raised, with every step reference resolved to the step's own name.
const buildWorkflowRunFlowControl = ({ meta, stepNameByStepId } = {}) => {
  const safeMeta = toSafeObject(meta);
  const toleratedFailures = Array.isArray(safeMeta.toleratedFailures) ? safeMeta.toleratedFailures : [];
  const flowControlNotifications = Array.isArray(safeMeta.flowControlNotifications) ? safeMeta.flowControlNotifications : [];

  if (toleratedFailures.length < 1 && flowControlNotifications.length < 1) {
    return null;
  }

  const nameByStepId = toSafeObject(stepNameByStepId);

  return {
    toleratedFailures: toleratedFailures.map((failure) => {
      const stepId = toSafeString(failure?.stepId);
      // The sentence that says what happened and, where one is known, the fix; the app's own words follow it. A
      // tolerated failure is a step error by definition, which is the sentence an unknown provider code falls back to.
      const display = resolvePieveWorkflowRunFailureDisplay({ failure: { failureReason: 'step_error', code: failure?.code, message: failure?.message, failedStepId: stepId }, stepNameByStepId });

      return {
        stepName: toSafeString(nameByStepId[stepId]) || stepId || 'Step',
        action: getFlowActionLabel(failure?.action) || 'Tolerated',
        headline: display?.headline || null,
        message: resolvePieveWorkflowStepIdsInText({ text: failure?.message, stepNameByStepId }),
        itemLabel: Number.isInteger(failure?.loopIndex) ? `Item ${failure.loopIndex + 1}` : null,
        expected: failure?.expected === true,
        record: failure
      };
    }),
    flowControlNotifications: flowControlNotifications.map((notification) => {
      return {
        ...notification,
        message: resolvePieveWorkflowStepIdsInText({ text: notification?.message, stepNameByStepId })
      };
    })
  };
};

export default buildWorkflowRunFlowControl;
